import {
  setMap,
  setLatLng,
  setPos,
  setDistance,
  setService,
  setCurrentDistance,
  setCurrentService,
  unsetCurrentService,
  resetCurrentService,
  setActiveTab,
  setMarkers,
  setSearch,
} from '@/storeFinder/context/action-creators';

export default dispatch => ({
  setMap: payload => dispatch(setMap(payload)),
  setLatLng: payload => dispatch(setLatLng(payload)),
  setPos: payload => dispatch(setPos(payload)),
  setDistance: payload => dispatch(setDistance(payload)),
  setService: payload => dispatch(setService(payload)),
  setCurrentDistance: payload => dispatch(setCurrentDistance(payload)),
  setCurrentService: payload => dispatch(setCurrentService(payload)),
  unsetCurrentService: payload => dispatch(unsetCurrentService(payload)),
  resetCurrentService: payload => dispatch(resetCurrentService(payload)),
  setActiveTab: payload => dispatch(setActiveTab(payload)),
  setMarkers: payload => dispatch(setMarkers(payload)),
  setSearch: payload => dispatch(setSearch(payload)),
});
